
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifecycle-studio/images",
      function () {
        return require("private-next-pages/lifecycle-studio/images.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifecycle-studio/images"])
      });
    }
  